var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "item-hours" }, [
    _c("span", { staticClass: "country" }, [
      _vm._v(_vm._s(_vm.time.format("z")))
    ]),
    _vm._v(" "),
    _c("span", { staticClass: "hour" }, [
      _vm._v(_vm._s(_vm.time.format("HH:mm")))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a8e3aa5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a8e3aa5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/HeaderTime.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6a8e3aa5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/HeaderTime.vue
// module chunks = 0